import { emitOpenEvent } from './emitter';

const buildWidgetTrackingData = (widgetTracking, featureIndex) => {
  return {
    ...widgetTracking,
    position: Number(featureIndex),
    status: 'loaded'
  };
};
const buildProductTrackingData = (productTracking) => ({
  ...productTracking,
  status: 'loaded'
});

const track = (widgetTracking, visibleProductTracking, featureIndex) => {
  const productEvents = visibleProductTracking.map((it) => buildProductTrackingData(it));
  const features = [buildWidgetTrackingData(widgetTracking, featureIndex), ...productEvents];
  const event = {
    name: 'open',
    features: features
  };
  emitOpenEvent(event, {});
};

export default track;
